module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The First Judgement")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/9780310096153_template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "chapter",
      "title": "Chapter2"
    }
  }, [_c('p', {
    staticClass: "chnum",
    attrs: {
      "id": "ch2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#R_ch2"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_vm._v("CHAPTER TWO")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtitle"
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/text/nav#R_ch2"
    }
  }, [_vm._v("Meggido")])])]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_c('i', [_c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v(" 4")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v("t was nearing dusk. The eight-year-old Jesus stopped to catch his breath, surveying the hills of Galilee to the north and the majestic snow-crowned Mount Hermon. Then he turned his gaze to the west, where the magnificent purple Mount Carmel rose, beyond which lay the fringe of silvery sand of the Great Sea.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To the east lay Tabor and the unending string of exotic caravans from Arabia, Africa, and India, wending their way along the bustling eastern spice-trade routes that linked Egypt with Syria.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But it was the great plain to the south that commanded the young boy’s full attention.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He clambered over the stones, up the rocky slopes of the Nazareth Ridge, his eyes filled with an ardent fervour, oblivious to the carpet of richly coloured flowers and sharp stones under his feet, his attention riveted on the monstrous magnificent valley that sprawled before him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally he stopped, gasping for breath, having reached the summit of the eastern slope, the soft breezes ruffling his "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_vm._v("long, dark curls, his bare feet sinking into the thyme and mountain flowers beneath him. Staring.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Staring at the Great Battlefield of Israel . . . Esdraelon, the Valley of Jezreel. Armageddon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Far away in the distance, across the fertile valley, stood two imperial figures: Michael and Gabriel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He sees the future,’ Gabriel whispered. ‘The final war.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Armageddon.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jesus stared at the great plains before him, now filled with a vast multitude, every nation represented in the violent, bloody panaroma before them: Chinese, Arab, European, American, African, Australian soldiers, their bloodthirsty cries of battle mingling with agonized screams of the dying. The Prince of Peace watched, pale and silent, as the Son of Perdition and the great kings of the earth gathered with their armies, a great and terrible multitude two hundred million strong . . . waiting . . .")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Huge hailstones fell from the skies onto the terrorized militia. The colossal tectonic plates of the earth shifted and the mountains shuddered as their foundations collapsed, levelling them – the Alps, Himalayas, Andes, all melting like wax. A thousand great and terrible whirlwinds rose from the south, merging with the colossal frenzied eyes of force-five hurricanes, raging from the east and west coasts of North America. Monsoons seethed from the Far East. Tsunamis erupted from ferocious seas, and now the moon turned to blood in the sky.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And then, as he viewed the 200-million-man army before him, he saw men’s flesh literally rotting away as they stood, soldiers’ eyes disintegrating in their sockets, their tongues melting in their mouths as the Valley of Jezreel became like a winepress, blood rising up to the horses’ bridles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jesus bowed his head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Instantly the horrific scene before them vanished, and Michael and Gabriel were gone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_vm._v("Jesus held his head in his hands, breathing rapidly in shallow gasps, then lifted his face and gazed once more at the now tranquil, fertile emerald plains of the valley.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘In the latter time he has made it glorious, by the way of the sea, beyond the Jordan, Galilee of the nations,’ he whispered. ‘The people who walked in darkness have seen a great light.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He stared up at the cloudless blue skies, at the lines of pink-backed pelicans and yellow-billed storks as they fluttered overhead, winging their way to the Lake of Galilee.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A strange aroma of frankincense filled the air. Jesus turned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There, just paces away from him on the eastern summit, stood Lucifer, studying the eight-year-old boy . . . his adversary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why are you on my planet, Nazarene?’ His voice was soft but his blazing blue eyes were filled with loathing. He moved closer to Jesus. ‘What is it you want?’ His voice was low, mesmerizing. He circled the boy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘When the seal of the seventh stone is lifted, you shall know my vengeance.’ A slight smile played on Lucifer’s lips. ‘You shall indeed suffer, Nazarene – away from "), _c('i', [_vm._v("him")]), _vm._v(".’ Then he was gone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nothing stirred, just the soft gusts of mountain air that blew Jesus’ locks, and the faint aroma of frankincense that still lingered on the breeze.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fab018f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780310096153_Chapter2.vue
// module id = 78
// module chunks = 0